import PictureScene from '../picture-scenes/picture-scene.entity';
import Picture from '../pictures/picture.entity';
import { SosDeleteResponse, SosListResponse } from '../sos-response';

export interface PictureSceneDeleteResponse extends SosDeleteResponse {
	destroyed: {
		PictureScene: PictureScene[];
	};
}

export interface PictureSceneListResponse extends SosListResponse {
	listed: {
		Picture: Picture[];
		PictureScene: PictureScene[];
	};
}
